import { createSlice } from "@reduxjs/toolkit";
import { ComplaintInterface } from "../../components/Complaints/types";

interface props {
  isFetching: boolean,
  complaints: ComplaintInterface[],
  error: string[]
}
const initialState: props = {
  isFetching: false,
  complaints: [],
  error: []
}
const complaintSlice = createSlice({
  name: "complaints",
  initialState,
  reducers: {
    statusComplaintStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusComplaintSuccess: (state, action) => {
      state.isFetching = false
      state.complaints = action.payload
      state.error = []
    },
    statusComplaintFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusComplaintStart,
  statusComplaintSuccess,
  statusComplaintFailure 
} = complaintSlice.actions

export default complaintSlice.reducer